import {
  postV2ApiScaAuthenticationOperationsValidateProcedureWithTotp,
  postV2ApiAuthenticationOperationsOperationId,
} from 'src/client/spendesk-api';

export const validateLoginAuthenticationOperation = async (
  totpToken: string,
  scaToken: string,
  validateTrustedDevice = false,
): Promise<
  | { outcome: 'success' }
  | { outcome: 'failure'; errorCode: 'token-invalid' | 'token-expired' }
> => {
  const response =
    await postV2ApiScaAuthenticationOperationsValidateProcedureWithTotp({
      headers: {
        authorization: `Bearer ${scaToken}`,
      },
      body: {
        token: totpToken,
        validateTrustedDevice,
      },
    });

  if (response.statusCode === 400 || response.statusCode === 422) {
    return {
      outcome: 'failure',
      errorCode: 'token-invalid' as const,
    };
  }

  return {
    outcome: 'success',
  };
};

export const validateAuthenticationOperation = async ({
  operationId,
  token,
}: {
  operationId: string;
  token: string;
}) => {
  const response = await postV2ApiAuthenticationOperationsOperationId({
    body: {
      token,
    },
    path: {
      operationId,
    },
  });

  if (response.statusCode === 400) {
    return {
      outcome: 'failure',
      errorCode: 'token-invalid' as const,
    };
  }

  return {
    outcome: 'success',
  };
};
